import { IconSet } from '../IconSet';

/**
 * These icons require the FFXC prefix to avoid collisions with the other icons.
 *
 * The values here must match the unicode value of the character in the font.
 * You can get this value from https://iconcloud.design
 */
const icons = {
  // Component Manifest
  FFXCTable: '\uED86',
  FFXCEventDate: '\uF059',
  FFXCEventDuration: '\uED9C',
  FFXCPhoto2: '\uEB9F',
  FFXCCalendarAgenda: '\uEE9A',
  FFXCAltText: '\uE397',
  FFXQuestionAnswer: '\uE4F0',

  // Presence
  FFXCPawn: '\uE77B',

  // Tablero
  FFXCAdd: '\uE710',
  FFXCCalendar: '\uE787',
  FFXCCircleAdditionSolid: '\uF2E4',
  FFXCCircleRing: '\uEA3A',
  FFXCDelete: '\uE74D',
  FFXCGripperDotsHorizontal: '\uF772',
  FFXCStatusCircleInner: '\uF137',
  FFXCSortDown: '\uEE69',
  FFXCSortUp: '\uEE68',
  FFXCSort: '\uE8CB',
  FFXCInsertRowsAbove: '\uF64C',
  FFXCInsertRowsBelow: '\uF64D',
  FFXCInsertColumnsRight: '\uF64B',
  FFXCInsertColumnsLeft: '\uF64A',
  FFXCDeleteRows: '\uF64F',
  FFXCDeleteColumns: '\uF64E',
  FFXCMoveUp: '\uE74A',
  FFXCMoveDown: '\uE74B',
  FFXCMoveRight: '\uE72A',
  FFXCMoveLeft: '\uEC52',
  FFXCOEM: '\uE74C',
  FFXCCheckMark: '\uE73E',
  FFXCReplyAlt: '\uEF5E',
  FFXCCCBRow: '\uF278',
  FFXCCCBDelete: '\uF651',
  FFXCCCBMove: '\uE7C2',
  FFXCCCBColumn: '\uE438',

  // Scriptor:
  FFXCAccounts: '\uE910',
  FFXCEdit: '\uE70F',
  FFXCOpenInNewTab: '\uF6AB',
  FFXCRemoveLink: '\uED90',
  FFXCConvertToTable: '\uED86',
  FFXCCommentAdd: '\uF2B3',
  FFXCGroup: '\uE902',

  // Commanding Surface
  FFXCInsertTextBox: '\uEC7D',
  FFXCClipboardList: '\uF0E3',
  FFXCBulletedList: '\uE8FD',
  FFXCNumberedList: '\uEA1C',
  FFXCChecklist: '\uE9D5',
  FFXCCompleted: '\uE930',
  FFXCLink: '\uE71B',
  FFXCUndo: '\uE7A7',
  FFXCRedo: '\uE7A6',
  FFXCCopy: '\uE8C8',
  FFXCPaste: '\uE77F',
  FFXCBold: '\uE8DD',
  FFXCCut: '\uE8C6',
  FFXCHeader1: '\uEA19',
  FFXCHeader2: '\uEF36',
  FFXCHeader3: '\uEF37',
  FFXCItalic: '\uE8DB',
  FFXCMore: '\uE712',
  FFXCStrikethrough: '\uEDE0',
  FFXCUnderline: '\uE8DC',
  FFXCChevronRight: '\uE76C',
  FFXCChevronLeft: '\uE76B',
  FFXCEyeSlash: '\uF6AC',
  FFXCCompletedSolid: '\uEC61',

  // office-bohemia-ux
  FFXCEmoji: '\uE899',
  FFXCShare: '\uE72D',
  FFXCUpload: '\uE898',
  FFXCLocaleLanguage: '\uF2B7',
  FFXCInfo: '\uE946',

  // Calendar
  FFXCUpArrow: '\uE74A',
  FFXCDownArrow: '\uE74B',
  FFXCCloseIcon: '\uE947',

  // Duration
  FFXCClock: '\uE917',

  // AtMentions
  FFXCPeopleAdd: '\uEA15',
  FFXCPersonAdd: '\uE8FA',

  // Dias
  FFXCCalendarEdit: '\uF05B',

  // CheckboxRichText
  FFXCBulbIcon: '\uE3AF',

  // ErrorFramework
  FFXCCancel: '\uE711',
  FFXCErrorBadge: '\uEA39',
  FFXCBlocked: '\uECE4',
  FFXCError: '\uE783'
};

const localizedIcons = {
  FFXCCalendarMirrored: '\uED28',
  FFXCBulletedListMirrored: '\uEA42',
  FFXCClipboardListMirrored: '\uF0E4',
  FFXCNumberedListMirrored: '\uE398',
  FFXCChecklistMirrored: '\uF0B5',

  FFXCBoldF: '\uE5B5',
  FFXCBoldT: '\uE5C8',
  FFXCBoldK: '\uE5C6',
  FFXCBoldBulgarian: '\uE5C5',
  FFXCBoldKazakh: '\uE5C9',
  FFXCBoldSerbian: '\uE5CA',
  FFXCBoldP: '\uE5C7',
  FFXCBoldG: '\uE5B3',
  FFXCBoldN: '\uE5B7',
  FFXCBoldRussian: '\uE5B9',
  FFXCBoldKorean: '\uE5BD',

  FFXCItalicC: '\uE5B2',
  FFXCItalicD: '\uE5CE',
  FFXCItalicT: '\uE5D0',
  FFXCItalicL: '\uE5D1',
  FFXCItalicKazakh: '\uE5D2',
  FFXCItalicS: '\uE5CF',
  FFXCItalicK: '\uE5B6',
  FFXCItalicKorean: '\uE5BC',

  FFXCUnderlineS: '\uE5B4',
  FFXCUnderlineP: '\uE5CD',
  FFXCUnderlineA: '\uE5CC',
  FFXCUnderlineSerbian: '\uE5CB',
  FFXCUnderlineRussian: '\uE5B8',
  FFXCUnderlineKorean: '\uE5BB',

  FFXCStrikethroughKorean: '\uE5D4'
};

export const componentsIcons: IconSet = {
  fontFamily: 'components',
  fontExtension: 'woff',
  // Must be manually updated whenever there is a change of the font file.
  sha: '339f16b922',
  icons
};

export const componentsLocalizedIcons: IconSet = {
  fontFamily: 'components-localized',
  fontExtension: 'woff',

  // Must be manually updated whenever there is a change of the font file.
  sha: '223482e373',
  icons: localizedIcons
};

/**
 * Type containing the icon names of this icon set.
 */
export type ComponentsIconsType = keyof typeof icons;
export type ComponentsIconNames = ComponentsIconsType | keyof typeof localizedIcons;
